/* eslint-disable vue/attribute-hyphenation */
<!-- CORNEA Photo component -->
<template>
  <md-card id="cornea" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>remove_red_eye</md-icon>
        </div>
        <div class="md-layout-item">
          <h4 class="title" style="font-weight: 400">{{ SectionName }}</h4>
        </div>
        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            v-show="addnlCOR"
            slot="title"
            class="md-button md-warning md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click.prevent="toggleImgBox"
          >
            ADD'L IMAGES
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <!-- ROW HEADINGS -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: center">
        <div class="md-layout-item">
          <label for="diagCorOD" style="font-weight: bold">RIGHT</label>
        </div>

        <div class="md-layout-item">
          <label for="diagCorOS" style="font-weight: bold">LEFT</label>
        </div>
      </div>

      <hr style="width: 98%" />

      <!-- ROW images -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: Left">
        <div class="md-layout-item" style="padding: 2px 5px 2px 20px">
          <drop class="drop" @drop="handleDropOD">
            <img
              v-if="noCorOD"
              :style="imgStyle"
              name="paceholder"
              src="@/assets/img/imageNA.jpg"
              height="100px"
              width="auto"
            />

            <img
              v-else
              :src="imgCorOD"
              :style="imgStyle"
              name="imgCorOD"
              alt="Cornea OD"
              height="100px"
              width="auto"
              @click="corModal(imgCorOD)"
            />
          </drop>
        </div>

        <div class="md-layout-item" style="padding: 2px">
          <drop class="drop" @drop="handleDropOS">
            <img
              v-if="noCorOS"
              :style="imgStyle"
              name="paceholder"
              src="@/assets/img/imageNA.jpg"
              alt="Cornea OS"
              height="100px"
              width="auto"
            />

            <img
              v-else
              :src="imgCorOS"
              :style="imgStyle"
              name="imgCorOS"
              alt="Cornea OS"
              height="100px"
              width="auto"
              @click="corModal(imgCorOS)"
            />
          </drop>
        </div>
      </div>

      <hr style="width: 98%" />

      <!-- ROW LISTBOXES -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="margin-left: -15px">
        <findings-search :section="Section" :sectionName="SectionName" :mState="mState" />

        <hr style="margin: 0; padding: 0" />
      </div>
    </md-card-content>

    <hr />

    <!-- MODAL LARGE IMAGE -->
    <modal v-if="winModal" md-dynamic-height>
      <template slot="header">
        <div class="md-layout md-alignment-center-right">
          <div class="md-layout-item"></div>
          <div class="md-layout-item md-alignment-top-right">
            <md-icon class="exit-icon" style="color: red" @click.native="winModal = false">cancel</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div v-if="CorModal" class="md-layout" @click="winModal = false">
          <div class="md-layout-item">
            <img :src="ModalImg" height="300px;" width="auto" />
          </div>
        </div>
      </template>
    </modal>
  </md-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"
import FindingsSearch from "@/components/GlobeChek/screening/findings/Top5Findings"
import axios from "axios"
export default {
  name: "PhotoCornea",
  components: {
    "findings-search": FindingsSearch,
    Modal
  },
  props: {},
  data() {
    return {
      Section: "Cornea",
      SectionName: "Corneal Topography",
      replaceImgOD: null,
      replaceImgOS: null,
      mState: false,
      ModalImg: "",
      normal: null,
      normalStyle: "",
      winModal: false,
      CorModal: false,
      imgStyle: "",
      imgStyleInactive: "filter:grayscale(100%);",
      imgStyleActive: ""
    }
  },

  computed: {
    ...mapGetters(["corneaPhoto", "imagesPath", "addnlCOR", "getSignedImages"]),

    noCorOD() {
      if (this.replaceImgOD) {
        return false
      } else {
        if (this.getImageUrl("cornea", ["COROD"]) == false) {
          return true
        } else {
          return false
        }
      }
    },
    noCorOS() {
      if (this.replaceImgOS) {
        return false
      } else {
        if (this.getImageUrl("cornea", ["COROS"]) == false) {
          return true
        } else {
          return false
        }
      }
    },
    imgCorOD() {
      return this.getImageUrl("cornea", ["COROD"])
    },
    imgCorOS() {
      return this.getImageUrl("cornea", ["COROS"])
    }
  },
  mounted: function () {
    this.imgStyle = this.imgStyleInactive
    this.listAllImages()
  },

  methods: {
    ...mapActions(["imagePickerList"]),
    getImageUrl(category, ids = []) {
      const images = this.getSignedImages[category]
      if (!images || images.length === 0) return false

      const match = images.find((img) => ids.includes(img.id))
      return match ? match.url : false
    },
    listAllImages() {
      let payload = {
        pkgID: sessionStorage.getItem("storageID"),
        showPicker: false
      }
      this.$store.dispatch("imagePickerList", payload)
    },
    toggleImgBox() {
      bus.$emit("toggleImgBox", "COR")
    },
    mouseOver: function () {
      try {
        this.mState = true
        this.imgStyle = this.imgStyleActive
        this.normalStyle = false
      } catch (error) {
        console.log(error)
      }
    },
    mouseLeave: function () {
      try {
        this.mState = false
        this.imgStyle = this.imgStyleInactive
        this.normalStyle = "disabled"
      } catch (error) {
        console.log(error)
      }
    },
    clearModal() {
      this.winModal = false
      this.CorModal = false
      this.FindingModal = false
    },
    corModal: function (img) {
      this.clearModal()
      this.ModalImg = img
      this.winModal = true
      this.CorModal = true
    },
    handleDropOD(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOD = data.url
      this.$store.dispatch("SetImgReplace", { COROD: data.url })
      this.$forceUpdate()
    },
    handleDropOS(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOS = data.url
      this.$store.dispatch("SetImgReplace", { COROS: data.url })
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
#cornea {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 0px;
  background: #ccc;
  position: relative;
  padding: 0px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}

.md-layout-item.md-alignment-top-right {
  display: flex;
  justify-content: flex-end;
}

.exit-icon {
  cursor: pointer;
  margin: 0px;
  padding: 0px;
}
</style>
